import React, { FunctionComponent } from "react";
import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { TextWithReferences } from "./text-with-references";

const useStyles = makeStyles((theme: Theme) => ({
  cardTitles: {
    fontSize: 18,
    fontWeight: 700,
  },
  cardBottomBody: {
    fontSize: 14,
    fontWeight: 300,
    marginLeft: theme.spacing(1),
  },
}));

interface IHeaderWithIconButtonProps {
  text: string;
}

export const HeaderWithIconButton: FunctionComponent<IHeaderWithIconButtonProps> = (props) => {
  const { text } = props;
  const classes = useStyles();
  return (
    <Grid item>
      <Grid container alignItems="center">
        <Typography className={classes.cardTitles}>
          <TextWithReferences text={text} />
        </Typography>
      </Grid>
    </Grid>
  );
};
